import ADPModprefixnoService from "../../../../services/admin/ADPModprefixnoService";
import ADPModuleService from "../../../../services/admin/ADPModuleService";
import ADPTabauditService from "../../../../services/admin/ADPTabauditService";

class PrefixnoService {

  async create(data: any): Promise<any> {
    return await ADPModprefixnoService.create(data);
  }

  /**
   * Update an existing record by composite key (moduleId + documentType).
   */
  async update(moduleId: string, documentType: string, data: any): Promise<any> {
    return await ADPModprefixnoService.update(moduleId, documentType, data);
  }

  async updateList(): Promise<any> {
    return await ADPModprefixnoService.updateList();
  }



  async findAll(): Promise<any> {
    return await ADPModprefixnoService.findAll();
  }


  async getItemById(moduleId: string, documentType: string): Promise<any> {
    return await ADPModprefixnoService.getItemById(moduleId, documentType);
  }




  async delete(moduleId: string, documentType: string): Promise<any> {
    return await ADPModprefixnoService.delete(moduleId, documentType);
  }

  /**
   * (Optional) If you still want to store/retrieve state from localStorage.
   */
  async getClientState(): Promise<any> {
    const clientState = localStorage.getItem('clientState');
    return clientState ? JSON.parse(clientState) : null;
  }
  async getModuleDropdown(): Promise<any> {
    return await ADPModuleService.getDropdown();
  }
  async getTableDropdown(): Promise<any> {
    return await ADPTabauditService.getDropdown();
  }
  

}

export default new PrefixnoService();
